import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

const STORAGE_KEY = 'nightMode';

@Injectable({
  providedIn: 'root'
})
export class NightModeService {

  private nightMode = false;

  constructor(private overlayContainer: OverlayContainer) {
    this.init();
  }

  /** Initialisation au démarrage de l'app */
  private init() {
    const stored = localStorage.getItem(STORAGE_KEY);
    this.nightMode = stored === 'true';
    this.applyTheme();
  }

  /** Active / désactive le night mode */
  toggle() {
    this.setNightMode(!this.nightMode);
  }

  /** Force un état */
  setNightMode(value: boolean) {
    this.nightMode = value;
    localStorage.setItem(STORAGE_KEY, String(value));
    this.applyTheme();
  }

  /** Retourne l'état actuel */
  isNightMode(): boolean {
    return this.nightMode;
  }

  /** Applique la classe CSS */
  private applyTheme() {
    const html = document.documentElement.classList;
    const overlayClasses = this.overlayContainer
      .getContainerElement()
      .classList;

    if (this.nightMode) {
      html.add('nightMode');
      overlayClasses.add('nightMode');
    } else {
      html.remove('nightMode');
      overlayClasses.remove('nightMode');
    }
  }
}
